import {
  bit8TrackerList,
  bit9TrackerList,
  bit10TrackerList,
  noAccTrackerList,
  iridiumTrackerList,
} from '../config/selectList'

/**
 * 判定 tracker 是否为铱星硬件机型（按机型名称判定，与当前网络状态无关）。
 * 不同环境同一机型的 tracker_type_id 不一致（如现网 T633Li=3007），不能按 id 判定。
 * 机型名单复用 selectList.js 的 iridiumTrackerList（T633Li / T622G_F9 / T622E_F9），
 * 与后端 IridiumHelper.IridiumTrackerTypeNames 保持一致。
 * 前端 PTracker DTO 字段是 `typeName`；后端实体字段是 `tracker_type_name`，两者都接受。
 * 注意：deviceUtil.me 上还有同名的 isIridiumDevice(that, sssid)，它检查的是
 * "当前是否走铱星网络"——语义不同，不要混用。
 */
export function isIridiumTrackerType(tracker) {
  if (!tracker) return false
  const name = tracker.typeName || tracker.tracker_type_name || tracker.type_name
  if (!name) return false
  const lower = String(name).toLowerCase()
  return iridiumTrackerList.some((t) => t.toLowerCase() === lower)
}

var me = {
  that: null,

  getUploadTime: function (that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      return deviceLastLoc.receivedTime
    }
    return ''
  },

  getDeviceSpeed: function (that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      return deviceLastLoc.speed + 'km/h'
    }
    return '0km/h'
  },

  getDeviceSpeedNum: function (that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      return deviceLastLoc.speed
    }
    return 0
  },

  getDeviceJourney(that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      // return (deviceLastLoc.journeyStr) + "km"
      return deviceLastLoc.journeyStr + ''
    }
    return '0km'
  },
  getDeviceSatellites(that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      return deviceLastLoc.satellites
    }
    return '0'
  },

  getDeviceUseNetwork(that, sssid) {
    var obdData = me.getDeviceObdData(that, sssid)
    if (obdData) {
      if (obdData['CAN0XA04B']) {
        return obdData['CAN0XA04B'].value
      }
    }
    return null
  },

  getDeviceIridiumRssi(that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null && deviceLastLoc.currentNetwork == 'Iridium') {
      return deviceLastLoc.iridiumRssi
    }
    return null
  },

  getDeviceState: function (that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      return deviceLastLoc.online
    }
    return false
  },
  getDeviceStateByItem: function (that, item) {
    var deviceIds = me.getDeviceIdsFromItem(item)
    for (let deviceId of deviceIds) {
      if (me.getDeviceState(that, deviceId)) {
        return true
      }
    }
    return false
  },
  getDeviceAlarmState: function (that, sssid) {
    var hasAlarm = false
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      if (deviceLastLoc.eventId > 0 && deviceLastLoc.eventId != 35) {
        hasAlarm = true
      }
    }
    var alarmLoc = me.getDeviceAlarmLoc(that, sssid)
    if (alarmLoc) {
      hasAlarm = true
    }
    return hasAlarm
  },

  getDeviceIStatusInfo: function (that, sssid, speed) {
    var name = 'offline'
    var str = '离线'
    if (me.getdeviceSSSid(sssid) === '') {
      return [(name += '.png'), str]
    }

    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    var device = me.getDevice(that, sssid)
    var isOnline = false
    var hasAlarm = false
    var isParking = false
    var gpsValid = false
    var isIdling = false
    var isNeverLocate = false
    var isAccOn = false
    var isIridiumOnline = false
    if (deviceLastLoc != null) {
      isOnline = deviceLastLoc.online
      var state = deviceLastLoc.trackerState
      const date1 = new Date(deviceLastLoc.gpsTime)
      const date2 = new Date('2010-01-01 00:00:00')
      if (isOnline && date1.getTime() < date2.getTime() && !deviceLastLoc.gpsAvailable) {
        isNeverLocate = true
      }
      var isAccOff = false
      var trackerType = me.getDeviceType(that, sssid)

      // 将16进制字符串转换为整数
      var intValue = parseInt(state, 16)

      // 将整数转换为8位二进制字符串
      var binaryString = intValue.toString(2).padStart(12, '0')

      var bitArray = binaryString.split('').reverse()
      // 获取第二个bit的值
      var bit2 = bitArray[2]

      // T633L的trackerState为5个字节，最后一个字节代表输出，需要根据各种机型进行判断
      // if (deviceLastLoc.trackerState.length == 10) {
      // 	bit2 = bitArray[10];
      // }

      var bitState = '0'

      var bit8TrackerArr = bit8TrackerList
      var bit9TrackerArr = bit9TrackerList
      var bit10TrackerArr = bit10TrackerList

      if (bit8TrackerArr.findIndex((data) => data == trackerType) != -1) {
        bitState = bitArray[8]
      } else if (bit9TrackerArr.findIndex((data) => data == trackerType) != -1) {
        bitState = bitArray[9]
      } else if (bit10TrackerArr.findIndex((data) => data == trackerType) != -1) {
        bitState = bitArray[10]
      }

      if (bitState == '1') {
        isAccOn = true
      } else {
        isAccOff = true
      }

      if (noAccTrackerList.findIndex((data) => data == trackerType) != -1) {
        isAccOn = false
        isAccOff = false
      }

      gpsValid = deviceLastLoc.gpsAvailable
      isParking = deviceLastLoc.speed <= speed ?? 0
      if (deviceLastLoc.eventId > 0 && deviceLastLoc.eventId != 35) {
        hasAlarm = true
        if (deviceLastLoc.eventId == 133) {
          isIdling = true
        }
      }
    } else {
      isNeverLocate = true
    }

    if (isOnline && deviceLastLoc != null && deviceLastLoc.currentNetwork == 'Iridium') {
      isIridiumOnline = true
    }

    var alarmLoc = me.getDeviceAlarmLoc(that, sssid)
    if (alarmLoc) {
      hasAlarm = true
    }

    if (isOnline) {
      var pngStr = 'on'
      str = '在线'
      if (gpsValid) {
        if (isParking && (isAccOn || isAccOff)) {
          str += ',停车'
          pngStr += '_p'
          if (isAccOn) {
            pngStr += '_accon'
            str += ',点火'
          } else if (isAccOff) {
            pngStr += '_accoff'
            str += ',熄火'
          }

          if (hasAlarm) {
            pngStr += '_alarm'
            str += ',报警'
          }

          if (isIdling) {
            pngStr += '_idling'
            str += ',怠速'
          }
        } else {
          if (hasAlarm) {
            pngStr += '_t_alarm'
            str += ',行车有报警'
          }

          if (isIdling) {
            pngStr += '_t_idling'
            str += ',行车怠速'
          }
        }
      } else {
        if (isNeverLocate) {
          pngStr = 'off_nolocate'
        } else {
          pngStr = 'on_nolocate'
        }
        str += ',定位无效1111111'
      }

      if (pngStr == 'on') {
        pngStr = 'online'
        str = '在线'
      }
      name = pngStr
    } else {
      //离线
      if (hasAlarm) {
        name = 'off_alarm'
        str = '离线,报警'
      } else if (!gpsValid) {
        if (isNeverLocate) {
          name = 'off_nolocate'
        } else {
          name = 'offline'
        }
        str = '离线,定位无效'
      } else {
        name = 'offline'
      }
    }

    if (isIridiumOnline && name != 'offline' && name != 'off_alarm' && name != 'off_nolocate') {
      name = 'iridium_' + name
    }

    return [(name += '.png'), str]
  },

  //获取报警事件描述
  getAlarmStrById: function (id) {},

  //获取车状态,1=在线 2=未定位 3=有报警 4=怠速过长 5=停车 0=不在线
  getDeviceStatePlus: function (that, sssid) {
    var deviceLastLoc = me.getDeviceLastLoc(that, sssid)
    if (deviceLastLoc != null) {
      if (deviceLastLoc.online) {
        //
      }
    }

    return 0
  },

  getDeviceLastLoc: function (that, sssid) {
    var device = me.getDevice(that, sssid)
    if (device != null) {
      if (device.lastLoc != null) {
        return device.lastLoc
      }
    }
    return null
  },

  getDeviceObdData: function (that, sssid) {
    var device = me.getDevice(that, sssid)
    if (device != null) {
      if (device.obdData != null) {
        return device.obdData
      }
    }
    return null
  },

  getDeviceAlarmLoc: function (that, sssid) {
    var device = me.getDevice(that, sssid)
    if (device != null) {
      if (device.lastAlarm != null) {
        return device.lastAlarm
      }
    }
    return null
  },

  getDevice: function (that, sssid) {
    if (that.GLOBAL.trackerMap != undefined) {
      return that.GLOBAL.trackerMap.get(me.getdeviceSSSid(sssid)) || null
    }
    return null
  },

  getdeviceSSSid(sssid) {
    if (sssid == null) {
      return ''
    }

    const deviceId = String(sssid)
    if (deviceId.indexOf('|') > 0) {
      return deviceId.slice(deviceId.lastIndexOf('|') + 1)
    }
    return deviceId
  },

  isIridiumDevice: function (that, sssid) {
    var device = me.getDevice(that, sssid)
    if (device && device.lastLoc && device.lastLoc.currentNetwork == 'Iridium') {
      return true
    }
    if (device && device.lastLoc && device.lastLoc.online && device.obdData) {
      var can = device.obdData['CAN0XA04B']
      if (can && (can.value == 'Iridium' || can.Value == 'Iridium')) {
        return true
      }
    }
    return false
  },

  isIridiumDeviceByItem: function (that, item) {
    var deviceIds = me.getDeviceIdsFromItem(item)
    for (let deviceId of deviceIds) {
      if (me.isIridiumDevice(that, deviceId)) {
        return true
      }
    }
    return false
  },

  getDeviceIdsFromItem(item) {
    var deviceIds = []
    if (!item) {
      return deviceIds
    }
    if (item.sssid) {
      deviceIds.push(item.sssid)
    }
    if (item.id && deviceIds.indexOf(item.id) == -1) {
      deviceIds.push(item.id)
    }
    return deviceIds
  },

  getDeviceType: function (that, sssid) {
    if (that.GLOBAL.trackerMap != undefined) {
      var tracker = that.GLOBAL.trackerMap.get(me.getdeviceSSSid(sssid))
      if (tracker != null) {
        return tracker.tracker.typeName
      }
    }
    return null
  },

  getDeviceObjectType: function (that, sssid) {
    if (that.GLOBAL.trackerMap != undefined) {
      var tracker = that.GLOBAL.trackerMap.get(me.getdeviceSSSid(sssid))
      if (tracker != null) {
        return tracker.tracker.objectTypeId
      }
    }
    return null
  },

  getDeviceProtocol: function (that, sssid) {
    if (that.GLOBAL.trackerMap != undefined) {
      var tracker = that.GLOBAL.trackerMap.get(me.getdeviceSSSid(sssid))
      if (tracker != null) {
        return tracker.tracker.protocol
      }
    }
    return null
  },

  /** 按机型名称判定是否为铱星硬件型号（CCA 功能用此辅助） */
  isIridiumTrackerType: isIridiumTrackerType,
}
export default me
